import React from 'react';
import { CardComponentProps } from './types';

/**
 * Card header component for use with the Card component
 */
export const CardHeader: React.FC<CardComponentProps> = ({
  children,
  className = '',
}) => <div className={`p-4 border-b ${className}`}>{children}</div>;
